import { configGame } from "../../../data/config";
import { frameworkGridContainer } from "./../../../core/components/gridcontainer/configuration/gridcontainerconfiguration";
import { basegameAssetConfig } from "../../../data/basegame/index";
frameworkGridContainer.data = {
    "GRID_COLUMN": 0,
    "GRID_WIDTH": configGame.REEL_WIDTH,
    "GRID_ROWS": configGame.REEL_ROWS,
    "GRID_GAP": configGame.REEL_GAP,
    "SYMBOL_WIDTH": configGame.SYMBOL_WIDTH,
    "SYMBOL_HEIGHT": configGame.SYMBOL_HEIGHT,
    "HIDE_MASK": true,
    "GRID_CONTAINER_X": configGame.REEL_CONTAINER_X,
    "GRID_CONTAINER_Y": configGame.REEL_CONTAINER_Y,

    child: [

        {
            "id": "GameGridContainer",
            "name": "GameGridContainer",
            "type": "Tag",
            "class": "",
            "filterTypes": [],
            child: [

            ]
        },
    ]
}